import {
  LOGIN_SUCCESS,
  LOGOUT_REQUEST,
  UPDATE_USER_TYPE,
  USER_TYPE,
} from "../actions/action-type";

export const loginSuccess = (payload) => {
  return {
    type: LOGIN_SUCCESS,
    payload,
  };
};

export const logout = () => {
  return {
    type: LOGOUT_REQUEST,
  };
};

export const setUsersType = (payload) => {
  return {
    type: USER_TYPE,
    payload,
  };
};

export const updateUsersType = (payload) => {
  return {
    type: UPDATE_USER_TYPE,
    payload,
  };
};
